module.exports = __webpack_public_path__ + "img/s5-rabbit.cfa0cc46.png";